import type { ObstacleType } from './types'

const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v))

const rectsOverlap = (
  ax: number,
  ay: number,
  aw: number,
  ah: number,
  bx: number,
  by: number,
  bw: number,
  bh: number,
) => ax < bx + bw && ax + aw > bx && ay < by + bh && ay + ah > by

const makeRng = (seed: number) => {
  let s = seed
  return () => {
    s = (s * 1664525 + 1013904223) % 4294967296
    return s / 4294967296
  }
}

const BEST_SCORE_KEY = 'carRunner.bestScore.v1'

const readBestScore = () => {
  try {
    const raw = window.localStorage.getItem(BEST_SCORE_KEY)
    const n = raw ? Number(raw) : 0
    return Number.isFinite(n) ? n : 0
  } catch {
    return 0
  }
}

const writeBestScore = (value: number) => {
  try {
    window.localStorage.setItem(BEST_SCORE_KEY, String(Math.floor(value)))
  } catch {
    // ignore storage errors (private mode, etc.)
  }
}

const pickObstacleType = (rng: () => number): ObstacleType => {
  const roll = rng()
  if (roll < 0.45) return 'cone'
  if (roll < 0.85) return 'barrier'
  return 'hammer'
}

const makeObstacleDims = (type: ObstacleType, rng: () => number) => {
  if (type === 'cone') {
    return {
      w: Math.floor(12 + rng() * 10),
      h: Math.floor(18 + rng() * 20),
    }
  }
  if (type === 'barrier') {
    return {
      w: Math.floor(28 + rng() * 22),
      h: Math.floor(16 + rng() * 12),
    }
  }
  return {
    w: Math.floor(34 + rng() * 10),
    h: Math.floor(18 + rng() * 8),
  }
}

export {
  clamp,
  rectsOverlap,
  makeRng,
  readBestScore,
  writeBestScore,
  pickObstacleType,
  makeObstacleDims,
}
